<!-- 储值卡状态 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="storeCardStatus" type="storeCardStatus" clearable />
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-储值卡状态',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '状态：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const storeCardStatus = useQuery('storeCardStatus', props.value);

    return {
      storeCardStatus,
    };
  },
};
</script>
